import _ from "lodash";
import { IPolicyDescriptor } from "./model";
import { PolicyContainer } from "./policy";

/**
 * LicenseValidator class
 * 등록된 감사 정책에 따라 프로그램의 라이선스 유효성 검사
 * @class
 */
class LicenseValidator {
  // 라이선스 검사에 적용되는 정책 배열
  _auditPolicyContainer: Array<IPolicyDescriptor> = [];

  /**
   * 라이선스 검사에 사용할 정책 지정
   * @method
   * @name LicenseValidator#usePolicy
   * @param {string} name 정책 이름
   * @param {{[key:string]:any]}} params 정책에 사용되는 파라미터
   * @returns {boolean}
   */
  usePolicy(name: string, params: { [key: string]: any }): boolean {
    // 1. 사용을 요청한 라이선스 검사 정책을 검색
    const findPolicies = PolicyContainer.filter(
      (policy: IPolicyDescriptor) =>
        policy.name.toLowerCase() === name.toLowerCase()
    );

    // 2. 사용을 요청한 라이선스 정책이 없는 경우, false를 반환하고 종료
    if (findPolicies.length < 1) {
      return false;
    }

    // 3. 사용을 요청한 라이선스 정책을 검사 정책 목록에 추가
    this._auditPolicyContainer.push({
      name: findPolicies[0].name,
      function: findPolicies[0].function,
      params: _.cloneDeep(params),
    });

    return true;
  }

  /**
   * 라이선스 검사에 사용되는 정책 제거
   * @method
   * @name LicenseValidator#removePolicy
   * @param {string} name 정책 이름
   * @returns {boolean}
   */
  removePolicy(name: string): boolean {
    // 1. 제거 요청 정책의 이름이 검사 정책 목록에 등록되어 있는지 확인
    const policyIdx = this._auditPolicyContainer.findIndex(
      (policy) => policy.name.toLowerCase() === name.toLowerCase()
    );

    // 2. 등록되어있지 않다면, false를 반환하고 종료
    if (policyIdx === -1) {
      return false;
    }

    // 3. 등록되되어 있다면 해당 정책을 검사 정책 목록에서 제거 후
    // true를 반혼하고 종료
    this._auditPolicyContainer.splice(policyIdx, 1);
    return true;
  }

  /**
   * 등록된 검사 정책을 모두 실행하여 라이선스 유효성 검사
   * @method
   * @name LicenseValidator#verify
   * @returns {Promise<boolean>}
   */
  async verify(): Promise<boolean> {
    const numOfPolicies = this._auditPolicyContainer.length;
    for (let i = 0; i < numOfPolicies; i++) {
      const policy = this._auditPolicyContainer[i];
      const ret = await policy.function(policy.params);
      if (ret === false) {
        return false;
      }
    }
    return true;
  }

  /**
   * 사용 가능한 검사 정책 목록
   * @method
   * @name LicenseValidator#getSupportPolicies
   * @returns {Array<IPolicyDescriptor>}
   */
  getSupportPolicies(): Array<IPolicyDescriptor> {
    return PolicyContainer;
  }
}

export default LicenseValidator;
